export default __webpack_public_path__ + "assets/partly-cloudy-day-sleet.693b6fbf.svg";